<template>
	<div>
		<DialogCadastrarEmpresa
			:abrirDialog="cadastrar"
			:id="id"
			@loadEmpresas="loadEmpresas"
			@dialogClose="dialogClose"
		/>
		<DialogExluirEmpresa :abrirDialog="excluir" :id="id" @loadEmpresas="loadEmpresas" @dialogClose="dialogClose" />
		<v-row align="center" justify="center">
			<v-col md="11" xl="8">
				<CardPersonalizado titulo="Empresas" icone="mdi-office-building-outline">
					<div class="cabeçalho">
						<v-row>
							<v-col cols="12" class="pa-1">
								<v-text-field
									v-model="search"
									solo
									placeholder="Procure uma empresa"
									elevation="9"
									background-color="#FAFAFA"
									hide-details
								></v-text-field>
							</v-col>
							<!-- <v-col cols="12" md="3" class="pa-1">
								<v-btn
									class="white--text"
									color="#CC2128"
									elevation="9"
									@click="cadastrarEmpresa()"
									width="100%"
									large
								>
									<v-icon left> mdi-plus </v-icon>
									Cadastrar Empresa
								</v-btn>
							</v-col> -->
						</v-row>
					</div>
					<TabelaPersonalizada
						:headers="headers"
						:itens="empresas"
						:loading="loading"
						:total="total"
						@editar="editarEmpresa"
						@setOptions="setOptions"
					>
						<template v-slot:[`item.ativo`]="{ item }">
							<v-icon small class="mr-2">
								{{ retornarIcone(item.ativo) }}
							</v-icon>
						</template>
					</TabelaPersonalizada>
				</CardPersonalizado>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import CardPersonalizado from '../components/shared/cardPersonalizado.vue'
import TabelaPersonalizada from '../components/shared/tabelaPersonalizada.vue'
import DialogCadastrarEmpresa from '../components/empresas/DialogCadastrarEmpresa.vue'
import DialogExluirEmpresa from '../components/empresas/DialogExcluirEmpresa.vue'

import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			empresas: [],
			empresa: {},
			id: '',
			search: '',
			editar: false,
			cadastrar: false,
			excluir: false,
			loading: false,
			total: 0,
			options: {},
			headers: [
				{ text: 'Razão social', value: 'razaoSocial', sortable: false },
				{ text: 'Nome Fantasia', value: 'nomeFantasia', sortable: false },
				{ text: 'CNPJ', value: 'cpfCnpj', sortable: false },
				{ text: 'E-mail', value: 'email', sortable: false },
				{ text: 'Telefone', value: 'telefone', sortable: false },
				{ text: 'Ativo', value: 'ativo', algin: 'center', sortable: false },
			],
		}
	},
	components: {
		CardPersonalizado,
		TabelaPersonalizada,
		DialogCadastrarEmpresa,
		DialogExluirEmpresa,
	},
	methods: {
		async loadEmpresas() {
			try {
				this.loading = true

				const { page, itemsPerPage } = this.options
				const response = await this.axios.get('/empresas', {
					params: {
						search: this.search,
						limit: itemsPerPage,
						page,
					},
				})
				this.empresas = response.data.empresas
				this.total = response.data.total
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		setOptions(options) {
			this.options = options
			this.loadEmpresas()
		},
		cadastrarEmpresa() {
			this.cadastrar = true
		},
		editarEmpresa(id) {
			this.id = id
			this.cadastrar = true
		},
		excluirEmpresa(id) {
			this.id = id
			this.excluir = true
		},
		dialogClose() {
			this.cadastrar = false
			this.editar = false
			this.excluir = false
			this.id = ''
		},
	},
	mounted() {
		this.loadEmpresas()
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
	},
	watch: {
		search() {
			this.loadEmpresas()
			this.options.page = 1
		},
	},
}
</script>

<style scoped>
.cabeçalho {
	padding: 8px 8px 0 8px;
	margin-bottom: 20px;
}
.col {
	padding: 4px;
}
</style>
